export const defaultStartPath = '/app/home';

export const defaultLocale = 'en';
export const localeOptions = [
	{ id: 'en', name: 'English' },
];

export const apiUrl = `${process.env.API_ENDPOINT}/api/v1`;
